import React, {useCallback, useEffect, useState} from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {
    extendFreeze, extendFreezeSuccess,
    getTokenFreezeData,
    setExtendFreezeModalStatus,
} from "../../store/cabinet/action";
import 'react-toastify/dist/ReactToastify.css';
import {useTranslation} from "react-i18next";


const ExtendFreezeModal = () => {
    const dispatch = useDispatch();
    const extendFreezeModalStatus = useSelector(store => store.cabinet.extendFreezeModalStatus);
    const extendFreezeStatus = useSelector(store => store.cabinet.extendFreezeStatus);


    const tokenFreezeData  = useSelector(store => store.cabinet.tokenFreezeData);
    const { t } = useTranslation();

    const [currentPeriodId, setCurrentPeriodId] = useState(false);

    const closeModal = useCallback(() => {
        setCurrentPeriodId(false);
        dispatch(setExtendFreezeModalStatus({status: false, id: false}));
    }, [dispatch]);

    const mainBtnHandler =  () => {
        dispatch(extendFreeze({period_id: currentPeriodId}, extendFreezeModalStatus?.id))
    };

    useEffect(()=>{
        if (tokenFreezeData){
           setCurrentPeriodId(tokenFreezeData?.periods?.[0].id)
        }
    },[tokenFreezeData])

    useEffect(() => {
        if (extendFreezeModalStatus?.status) dispatch(getTokenFreezeData());
    }, [extendFreezeModalStatus, dispatch]);

    useEffect(()=>{
        if (extendFreezeStatus){
            closeModal();
            dispatch(extendFreezeSuccess(false));
        }
    },[extendFreezeStatus, dispatch, closeModal])


    return (
        <Popup
            open={extendFreezeModalStatus?.status}
            modal
            nested
            closeOnDocumentClick={false}
            closeOnEscape={false}
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}><div/><div/></div>
                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>{t('Продлить заморозку')}</div>
                    <div className={Styles.periodWrap}>
                        <div className={Styles.periodTitle}>{t('Выберите период заморозки')}</div>
                        <div className={Styles.periodBox}>
                            {tokenFreezeData?.periods?.map((item, index)=>{
                                return (
                                    <div className={`${Styles.periodItem} ${item.id === currentPeriodId ? Styles.periodItemActive : null}`} key={'period' + index} onClick={()=>{setCurrentPeriodId(item.id)}}>{item.days} {t('дней')}</div>
                                )
                            })}
                        </div>
                    </div>

                    <div
                        className={`${Styles.modalContentWrapMainBtn}`}
                        onClick={mainBtnHandler}
                        role="button"
                    >
                        {t('Продлить заморозку')}
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default ExtendFreezeModal;








